import { render, staticRenderFns } from "./relevantVideo.vue?vue&type=template&id=63322fe1&scoped=true&"
import script from "./relevantVideo.vue?vue&type=script&lang=js&"
export * from "./relevantVideo.vue?vue&type=script&lang=js&"
import style0 from "./relevantVideo.vue?vue&type=style&index=0&id=63322fe1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63322fe1",
  null
  
)

export default component.exports